/**
 * WD User Management - Login Popup
 *
 * Main entry point for login popup functionality.
 */

import Modal from './modal';
import Forms from './forms';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // Initialize modal controller
    window.wdLoginPopupModal = new Modal();

    // Initialize form handlers
    window.wdLoginPopupForms = new Forms();

    // Handle auto-show for first-time visitors
    if (window.wdLoginPopupAutoShow && window.wdLoginPopupModal) {
        const section = window.wdLoginPopup?.autoShowSection || 'login';

        // Small delay to ensure modal is ready
        setTimeout(() => {
            window.wdLoginPopupModal.open(section);

            // Set cookie to prevent showing again
            document.cookie = 'wd_lp_shown=1; path=/; max-age=86400';
        }, 500);
    }

    // Check URL hash for direct section opening
    checkHashTrigger();

    // Listen for hash changes
    window.addEventListener('hashchange', checkHashTrigger);
});

/**
 * Check URL hash for popup triggers.
 */
function checkHashTrigger() {
    const hash = window.location.hash;

    if (!hash || !window.wdLoginPopupModal) {
        return;
    }

    const hashMap = {
        '#wd-login-popup': 'login',
        '#wd-register-popup': 'register',
        '#wd-password-popup': 'password',
        // Backward compatibility with wlrp hashes
        '#wlrp-popup-login': 'login',
        '#wlrp-popup-register': 'register',
        '#wlrp-popup-password': 'password',
    };

    const section = hashMap[hash];

    if (section) {
        window.wdLoginPopupModal.open(section);

        // Clear hash without scrolling
        history.replaceState(null, '', window.location.pathname + window.location.search);
    }
}

// Export for external use
export { Modal, Forms };
